import { render, staticRenderFns } from "./article-detail.vue?vue&type=template&id=353ec7b1"
import script from "./article-detail.vue?vue&type=script&lang=ts"
export * from "./article-detail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports